// generated from 5_661 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const xSessionsInYDaysGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("x_sessions_in_y_days"),
  comparison_key: z.enum([
    "3", // 4_294 (75.85%)
    "1", // 1_056 (18.65%)
    "5", // 311 (5.49%)
  ]),
  display_name: z.string(),
  // undefined: 1_235 (21.82%), defined 4_426 (78.18%)
  raw_value: z
    .object({
      // avg: 17.77, min: 1, max: 30
      num_days: z.int().min(1).max(30),
      // avg: 0.59, min: 0, max: 50
      num_occurrences: z.int().min(0),
    })
    .optional(),
  value: z.object({
    // avg: 17.27, min: 1, max: 30
    num_days: z.int().min(1).max(30),
    // avg: 0.70, min: 0, max: 50
    num_occurrences: z.int().min(0),
  }),
  varies_by_app_group: z.literal(false),
});
